
import React from 'react';

const Uniswap = () =>{
  return (
      <div class="bg-loading bg-center bg-no-repeat min-h-96 min-w-96">
        <iframe
          title="a"
          src={"https://app.uniswap.org/#/swap?outputCurrency=" + process.env.REACT_APP_TOKEN_ADDRESS}
          height="660px"
          width="100%"
          class="max-w-screen-sm min-h-90 mx-auto rounded-lg pb-4"
        />
      </div>
  );
}

export default Uniswap;